import React from "react";

import StyledModal from "components/Modal";
import WarningBox from "components/WarningBox";

import { useAppDispatch } from "store/hooks";

import { deleteClientApiKey } from "store/features/clientApiKeySlice";

interface TokenDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TokenDeleteModal: React.FC<TokenDeleteModalProps> = (props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();

  const onSubmit = async () => {
    await dispatch(deleteClientApiKey()).unwrap();
    onCloseModal();
  };

  const onCloseModal = () => {
    onClose();
  };

  return (
    <StyledModal
      isOpen={isOpen}
      onClose={onCloseModal}
      title="Видалити Токен"
      content={
        <WarningBox content="Видалення токена призведе до припинення роботи всіх підключень до API IBAN oplata. Рекомендуємо переконатися, що токен більше не використовується, перш ніж продовжити." />
      }
      onAction={onSubmit}
      actionBtnText="Видалити Токен"
      actionBtnColor="error"
      actionBtnBorder
    />
  );
};

export default TokenDeleteModal;
